import React from 'react';
import './Hero.css';
import useInView from '../hooks/useInView';
import heroGraphic from '../assets/graphics/hero-graphic.png';
import whiteBackground from '../assets/images/white-background.png';

const Hero = ({ onOpenModal }) => {
  const { elementRef: heroRef, hasBeenInView: heroInView } = useInView();
  const { elementRef: visualRef, hasBeenInView: visualInView } = useInView();

  return (
    <section className="hero">
      <div className="hero-background">
        <img src={whiteBackground} alt="" className="background-pattern" />
      </div>
      <div className="container hero-container">
        <div className="hero-content">
          <div 
            className={`hero-text ${heroInView ? 'animate-fade-in-left' : ''}`}
            ref={heroRef}
          >
            <div className="hero-badge">
              <span>Sicurezza Aziendale</span>
            </div>
            <h1 className="hero-title">
              PROTEGGI IL TUO<br />
              <span className="hero-title-accent">BUSINESS</span>
            </h1>
            <p className="hero-description">
              <span className="highlight-blue">Antivirus italiano</span>, conforme al GDPR, progettato per proteggere 
              la tua attività dalle <span className="highlight-yellow">costanti minacce informatiche</span>.
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Made in Italy</span>
              </div>
              <div className="stat">
                <span className="stat-number">GDPR</span>
                <span className="stat-label">Compliant</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Supporto IT</span>
              </div>
            </div>
            <div className="hero-actions">
              <button className="btn btn-primary btn-large" onClick={onOpenModal}>
                <span>Scarica Subito</span>
                <span className="btn-icon">⬇</span>
              </button>
              <a href="#caratteristiche" className="btn btn-outline btn-large">
                <span>Scopri di Più</span>
                <span className="btn-icon">→</span>
              </a>
            </div>
          </div>
          <div 
            className={`hero-visual ${visualInView ? 'animate-fade-in-right' : ''}`}
            ref={visualRef}
          >
            <div className="hero-graphic-container">
              <img src={heroGraphic} alt="Cybersecurity Protection" className="hero-graphic" />
              <div className="protection-rings">
                <div className="ring ring-1"></div>
                <div className="ring ring-2"></div>
                <div className="ring ring-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 